export default __webpack_public_path__ + "static/media/iscrizione.4d897da5.png";